<script setup lang="ts">
/* eslint-disable vue/no-deprecated-slot-attribute */
import { ref, computed } from 'vue';
import { fetchUrl, getLicensePath } from './utils/util';
import Dependencies from './components/DependenciesComponent.vue';
import { ClientOnly } from '@seamless/oneweb-ssr/components';

const accordionItem = ref();
const fetchedLicenses = ref(new Map());

const props = defineProps({
  componentId: {
    type: String,
    required: true,
  },
  data: {
    type: Object,
    required: true,
  },
});

const toggleAccordionItem = async (path: string) => {
  // Check if already in local cache
  if (fetchedLicenses.value.has(path)) {
    return;
  }

  const fullAssetPath = getLicensePath(path, props.data);
  const response = await fetchUrl(fullAssetPath);
  fetchedLicenses.value.set(path, response);
};

const tableLabels = computed(() => {
  return {
    dependency: props.data.payload.dependencyLabel,
    version: props.data.payload.versionLabel,
    license: props.data.payload.licenseLabel,
    url: props.data.payload.urlLabel,
    link: props.data.payload.linkLabel,
  };
});
</script>

<template>
  <div class="wbx-grid-container">
    <div class="wb-margin-top-m">
      <div class="wb-heading-xl">{{ props.data.payload.title }}</div>
      <div
        v-if="props.data.payload.description"
        class="wb-heading-m wb-padding-top-xxs"
      >
        {{ props.data.payload.description }}
      </div>
      <div
        v-for="(tenant, license) in props.data.licenses.tenants"
        :key="license"
      >
        <div class="wb-padding-top-s wb-padding-bottom-s text-center">
          <h3 class="wb-heading-l">{{ tenant.name }}</h3>
        </div>
        <ClientOnly>
          <wb7-accordion
            class="wbx-grid-row"
            theme="light"
            prevent-mobile-flyout
          >
            <wb7-accordion-item
              class="accordion-item wbx-grid-col-mq4-6 wbx-grid-col-mq1-12 wb-margin-bottom-s"
              v-for="dependency in tenant.components"
              :key="dependency.name"
              @wbopen="() => toggleAccordionItem(dependency.path)"
              @wbaccordionitemopen="() => toggleAccordionItem(dependency.path)"
              ref="accordionItem"
            >
              <div slot="header" class="wb-text-l-strong flex">
                <p>{{ dependency.name }}</p>
              </div>
              <div slot="content">
                <div class="wb-text-l">
                  <Dependencies
                    v-if="fetchedLicenses.has(dependency.path)"
                    :dependencies="fetchedLicenses.get(dependency.path)"
                    :tableLabels="tableLabels"
                  />
                </div>
              </div>
            </wb7-accordion-item>
          </wb7-accordion>
        </ClientOnly>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.flex {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.accordion-item {
  height: min-content;
}
</style>
